import React from 'react';
import { _LIST_PAGINATION_MODEL } from '../../../../../store/modules/app/models';
import RecommendEventList from '../RecommendEventList';
import RecommendEventListSearchBox from '../RecommendEventListSearchBox';

const RecommendEventListWrap = (props) => {
  const { recommendEventList, setData, getList } = props;

  return (
    <div className="recommend-event-list-wrap">
      {/* 추천 상품 후기 검색 박스*/}
      <RecommendEventListSearchBox
        setData={(data) =>
          setData({
            path: ['recommendEventList', 'searchData', ...data.path],
            value: data.value,
          })
        }
        searchData={recommendEventList.searchData}
        getList={getList}
      />

      {/* 추천 상품 후기 리스트*/}
      <RecommendEventList
        recommendEventList={recommendEventList.list}
        initialOption={{
          pagination: _LIST_PAGINATION_MODEL,
        }}
        pagination={recommendEventList.pagination}
        getList={getList}
      />
    </div>
  );
};

export default RecommendEventListWrap;
